import { Injectable } from '@angular/core';

export type CategoriaFichero =
  | 'pdf'
  | 'word'
  | 'excel'
  | 'ppt'
  | 'imagen'
  | 'audio'
  | 'video'
  | 'texto'
  | 'generico';

@Injectable({ providedIn: 'root' })
export class TipoFicheroService {
  private static readonly MAPA: ReadonlyArray<[CategoriaFichero, ReadonlyArray<string>]> = [
    ['pdf', ['pdf']],
    ['word', ['doc', 'docx', 'odt']],
    ['excel', ['xls', 'xlsx', 'csv', 'ods']],
    ['ppt', ['ppt', 'pptx', 'odp']],
    ['imagen', ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp']],
    ['audio', ['wav', 'mp3', 'm4a', 'aac', 'ogg', 'flac', 'opus']],
    ['video', ['mp4', 'm4v', 'avi', 'mkv', 'mov', 'wmv', 'flv']],
    ['texto', ['txt']],
  ];

  // Path SVG (atributo d) del heroicon de cada categoría. Fuente única para el
  // componente Angular de tarjeta y para el HTML que emite markedOptionsFactory.
  private static readonly ICONOS: Record<CategoriaFichero, string> = {
    pdf: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z',
    word: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z',
    excel: 'M4.5 3.75h15a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5V5.25a1.5 1.5 0 0 1 1.5-1.5Zm0 0V5.25m0-1.5h15v.75m-7.5 4.5h6m-6 3h6m-6 3h6M4.5 9.75h3m-3 3h3m-3 3h3',
    ppt: 'M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605',
    imagen: 'm2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Z',
    audio: 'M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z',
    video: 'M15.75 10.5l4.72-2.36A.75.75 0 0 1 21.75 8.812v6.376a.75.75 0 0 1-1.28.53l-4.72-2.36M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z',
    texto: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z',
    generico: 'M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75m-.008 3h.008v.008H12v-.008ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  };

  // Clases Tailwind (fondo + texto) del recuadro de icono según categoría.
  private static readonly COLORES: Record<CategoriaFichero, string> = {
    pdf: 'bg-red-50 text-red-600',
    word: 'bg-blue-50 text-blue-600',
    excel: 'bg-emerald-50 text-emerald-600',
    ppt: 'bg-amber-50 text-amber-600',
    imagen: 'bg-violet-50 text-violet-600',
    audio: 'bg-indigo-50 text-indigo-600',
    video: 'bg-sky-50 text-sky-600',
    texto: 'bg-slate-100 text-slate-600',
    generico: 'bg-slate-100 text-slate-500',
  };

  categoria(nombre: string | undefined | null): CategoriaFichero {
    const extension = this.extension(nombre);
    if (!extension) {
      return 'generico';
    }
    for (const [categoria, extensiones] of TipoFicheroService.MAPA) {
      if (extensiones.includes(extension)) {
        return categoria;
      }
    }
    return 'generico';
  }

  iconoPath(categoria: CategoriaFichero): string {
    return TipoFicheroService.ICONOS[categoria];
  }

  claseColor(categoria: CategoriaFichero): string {
    return TipoFicheroService.COLORES[categoria];
  }

  // Etiqueta corta a mostrar en el recuadro (la extensión en mayúsculas), o '' si no hay.
  etiqueta(nombre: string | undefined | null): string {
    return this.extension(nombre).toUpperCase();
  }

  private extension(nombre: string | undefined | null): string {
    if (!nombre || typeof nombre !== 'string') {
      return '';
    }
    const limpio = nombre.trim().toLowerCase();
    if (!limpio.includes('.')) {
      return '';
    }
    return limpio.split('.').pop() ?? '';
  }
}
